import React from 'react';
import { Typography } from '@interstate/components/Typography';
import type { IFeeDropped } from '@makemydeal/dr-platform-types';

interface DroppedFeesListProps {
    fees: IFeeDropped[];
}

const DroppedFeesList = React.memo<DroppedFeesListProps>(function DroppedFeesList({ fees }) {
    if (fees.length === 0) return null;

    return (
        <ul style={{ paddingLeft: '15px', margin: 0 }}>
            {fees.map((fee: IFeeDropped, index: number) => (
                <li key={`${fee.feeName}-${index}`}>
                    <Typography variant="body-sm">
                        {fee.feeName} - ${fee.feeAmount}
                    </Typography>
                </li>
            ))}
        </ul>
    );
});

export default DroppedFeesList;
